export default "__VITE_ASSET__Bnc$nDYW__";